export default "__VITE_ASSET__$MeKtrvH__"